module.exports = __webpack_public_path__ + "img/BIT_white23.d0231504.jpg";